module.exports = __webpack_public_path__ + "static/img/logo_unitrus.bf0bbd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_unitrus.jpg
// module id = F7PY
// module chunks = 0